import React from 'react'

import { ContentLoader } from 'shared/components'

const renderImageLoader = (className) => (
  <div className={className}>
    <ContentLoader loading={true} />
  </div>
)

export default renderImageLoader
